import React from "react";
import UserBill from "../UserBill";
import UserNote from "../UserNote";
import UserFileHistoryModal from "./UserFileHistoryModal";
import UserLessonMarksModal from "./UserLessonMarksModal";
import UserLessonHistoryModal from "./UserLessonHistoryModal";
import UserErrorReportsModal from "./UserErrorReportsModal";
import UserContactMessagesModal from "./UserContactMessagesModal";

// New modular modals
import EditProfileModal from "./EditProfileModal";
import ChangePasswordModal from "./ChangePasswordModal";
import ChangeLoginInfoModal from "./ChangeLoginInfoModal";
import ChangeSchoolModal from "./ChangeSchoolModal";
import MoveClassRoomModal from "./MoveClassRoomModal";
import MoreInfoModal from "./MoreInfoModal";

const UserModals = ({
    activeModal,
    activeSubModal,
    activeUser,
    onClose,
    onSubmitEdit,
    onSubmitPassword,
    onSubmitLoginInfo,
    onSubmitChangeSchool,
    onSubmitChangeClassRoom,
    promiseSchoolOptions,
    promiseClassRoomOptions,
    onAction,
    t
}) => {
    if (!activeModal || !activeUser) return null;

    return (
        <>
            {/* Bills Modal */}
            {(activeModal === "bills" || activeSubModal === "bills") && (
                <UserBill handleClose={onClose} user={activeUser} />
            )}

            {/* Notes Modal */}
            {(activeModal === "notes" || activeSubModal === "notes") && (
                <UserNote handleClose={onClose} user={activeUser} />
            )}

            {/* Change Login Info Modal */}
            <ChangeLoginInfoModal
                show={activeModal === "changeLoginInfo" || activeSubModal === "changeLoginInfo"}
                onClose={onClose}
                user={activeUser}
                onSubmit={onSubmitLoginInfo}
                t={t}
            />

            {/* Change Password Modal */}
            <ChangePasswordModal
                show={activeModal === "change_password" || activeSubModal === "change_password"}
                onClose={onClose}
                user={activeUser}
                onSubmit={onSubmitPassword}
                t={t}
            />

            {/* Edit Profile Modal */}
            <EditProfileModal
                show={activeModal === "edit" || activeSubModal === "edit"}
                onClose={onClose}
                user={activeUser}
                onSubmit={onSubmitEdit}
                t={t}
            />

            {/* Change School Modal */}
            <ChangeSchoolModal
                show={activeModal === "changeSchool" || activeSubModal === "changeSchool"}
                onClose={onClose}
                user={activeUser}
                onSubmit={onSubmitChangeSchool}
                promiseSchoolOptions={promiseSchoolOptions}
                t={t}
            />

            {/* Move Student Class Room Modal */}
            <MoveClassRoomModal
                show={activeModal === "move" || activeSubModal === "move"}
                onClose={onClose}
                onSubmit={onSubmitChangeClassRoom}
                promiseClassRoomOptions={promiseClassRoomOptions}
                t={t}
            />

            {/* More Info Modal */}
            <MoreInfoModal
                show={activeModal === "moreInfo"}
                onClose={onClose}
                user={activeUser}
                onAction={onAction}
                t={t}
            />

            {/* Error Reports Modal */}
            {(activeModal === "errorReports" || activeSubModal === "errorReports") && (
                <UserErrorReportsModal
                    show={true}
                    onClose={onClose}
                    user={activeUser}
                    t={t}
                />
            )}

            {/* Contact Messages Modal */}
            {(activeModal === "contactMessages" || activeSubModal === "contactMessages") && (
                <UserContactMessagesModal
                    show={true}
                    onClose={onClose}
                    user={activeUser}
                    t={t}
                />
            )}

            {/* Download Files Modal */}
            {(activeModal === "downloadFiles" || activeSubModal === "downloadFiles") && (
                <UserFileHistoryModal
                    show={true}
                    onClose={onClose}
                    user={activeUser}
                    t={t}
                />
            )}

            {/* Lesson Marks Modal */}
            {(activeModal === "lessonMarks" || activeSubModal === "lessonMarks") && (
                <UserLessonMarksModal
                    show={true}
                    onClose={onClose}
                    user={activeUser}
                    t={t}
                />
            )}

            {/* Lesson Views Modal */}
            {(activeModal === "lessonViews" || activeSubModal === "lessonViews") && (
                <UserLessonHistoryModal
                    show={true}
                    onClose={onClose}
                    user={activeUser}
                    t={t}
                />
            )}
        </>
    );
};

export default UserModals;
